import React, { useState } from 'react';
import CommonLayout from '../../../layouts/Common';
import CommonTable from '../../../components/Common/Table';
import { ActionBtn, ActionBtnWrapper, HeaderData, NameData, UrlData } from './style';
import { ColumnsType } from 'antd/es/table';
import { DataType } from './type';
import { hrvData } from '../../../constants/dummy_data/hrv';
import IRCombiForm from '../../../components/Forms/Admin/IRCombi';
import useListAnalysesView from '../../../hooks/admin/useListAnalysesView';
import { formatDate } from '../../../helpers';
import IodineTestForm from '../../../components/Forms/Admin/IodineTest';
import { Spin } from 'antd';

const IodineTest = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { data: iodineTestData, total, loading, perPage } = useListAnalysesView('iodine', currentPage as number);
  const [openNewIodineTest, setOpenNewIodineTest] = useState<boolean>(false);
  const [openEditIodineTest, setOpenEditIodineTest] = useState<boolean>(false);

  const columns: ColumnsType<DataType> = [
    {
      title: <HeaderData>Client</HeaderData>,
      render: (text, record) => (
        <NameData>{`${record.client}`}</NameData>
      ),
    },
    {
      title: '',
      render: (text, record) => (
        <NameData>{`${record.clientGid}`}</NameData>
      ),
    },
    {
      title: <HeaderData>Professional</HeaderData>,
      render: (text, record) => (
        <NameData>{`${record.professional}`}</NameData>
      ),
    },
    {
      title: '',
      render: (text, record) => (
        <NameData>{`${record.professionalCode}`}</NameData>
      ),
    },
    {
      title: <HeaderData>Added by</HeaderData>,
      render: (text, record) => (
        <NameData>{`${record.addedBy}`}</NameData>
      )
    },
    {
      title: <HeaderData>Date</HeaderData>,
      render: (text, record) => (
        <UrlData>{`${formatDate(record.date)}`}</UrlData>
      ),
    },
    {
      title: <HeaderData>Actions</HeaderData>,
      render: (text, record) => (
        <ActionBtn
          active={record.professionalViewable}
          type="text"
          icon={
            <i className="material-icons-outlined" style={{ fontSize: 'inherit' }}>policy</i>
          }
        >
          {record.professionalViewable ? 'Disable' : 'Enable'}
        </ActionBtn>
      ),
    }
  ];

  const handleBack = () => {
    setOpenNewIodineTest(false);
    setOpenEditIodineTest(false);
  };

  return (
    <CommonLayout title="Iodine Tests" width="1000px">
      {loading ? <Spin size="large" /> :
        <CommonTable
          showNewModal={openNewIodineTest}
          onNewData={setOpenNewIodineTest}
          showEditModal={openEditIodineTest}
          onEditData={setOpenEditIodineTest}
          handleBack={handleBack}
          modalForm={<IodineTestForm />}
          modalWidth={1100}
          columns={columns}
          dataSource={iodineTestData}
          tableType="Iodine Tests"
          total={`${total} rows`}
          page={currentPage}
          setCurrentPage={setCurrentPage}
          perPage={perPage}
          totalData={total}
        />
      }
    </CommonLayout>
  )
};

export default IodineTest;